import HowToContent from "@SearchResults/features/staticContent/features/multiModal/components/HowToContent";
import HowLongContent from "@SearchResults/features/staticContent/features/multiModal/components/HowLongContent";
import HowMuchContent from "@SearchResults/features/staticContent/features/multiModal/components/HowMuchContent";
import HowManyTripsContent
    from "@SearchResults/features/staticContent/features/multiModal/components/HowManyTripsContent";
import WhatTransportTypeIsTheBestContent
    from "@SearchResults/features/staticContent/features/multiModal/components/WhatTransportTypeIsTheBestContent";
import FlightTipsContent
    from "@SearchResults/features/staticContent/features/multiModal/features/tips/components/FlightTipsContent";
import BusTipsContent
    from "@SearchResults/features/staticContent/features/multiModal/features/tips/components/BusTipsContent";
import TrainTipsContent
    from "@SearchResults/features/staticContent/features/multiModal/features/tips/components/TrainTipsContent";
import HowCanIBookContent
    from "@SearchResults/features/staticContent/features/multiModal/components/HowCanIBookContent";
import WhatIsMostPopularContent
    from "@SearchResults/features/staticContent/features/multiModal/components/WhatIsMostPopularContent";
import useSearchResults from "@SearchResults/hooks/useSearchResults";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import allOperatorsForTypeGetter from "@SearchResults/features/staticContent/functions/allOperatorsForTypeGetter";
import createAvailableOperatorsList
    from "@SearchResults/features/staticContent/features/multiModal/functions/createAvailableOperatorsList";
import FerryTipsContent
    from "@SearchResults/features/staticContent/features/multiModal/features/tips/components/FerryTipsContent";
import getSlowestAndFastestVehClassesInGeneral
    from "@SearchResults/features/staticContent/features/multiModal/functions/getSlowestAndFastestVehClassesInGeneral";
import getCheapestAndPriciestVehClassesInGeneral
    from "@SearchResults/features/staticContent/features/multiModal/functions/getCheapestAndPriciestVehClassesInGeneral";

interface MultipleTransportTypeContentProps {
    transportTypes: TransportTypesType[]
}

function MultipleTransportTypeContent({transportTypes}: MultipleTransportTypeContentProps) {
    const {data} = useSearchResults()

    const availableVehClasses = createAvailableOperatorsList(transportTypes)

    const {
        result: {
            companies,
            params: {
                departureStation: {
                    cityName: departure,
                },
                destinationStation: {
                    cityName: destination,
                },
            },
            singleRoutes,
        },
        staticContent: {landDistance, airDistance, ticketsSoldByTransportType},
    } = data

    const totalNumberOfTrips = singleRoutes.bus.length + singleRoutes.plane.length + singleRoutes.train.length + singleRoutes.ferry.length

    const {
        slowestInGeneralTransportType,
        fastestInGeneralTransportType,
    } = getSlowestAndFastestVehClassesInGeneral(transportTypes, singleRoutes)

    const {
        cheapestInGeneralTransportType,
        priciestInGeneralTransportType,
    } = getCheapestAndPriciestVehClassesInGeneral(transportTypes, singleRoutes)

    const {getAllOperatorsForType} = allOperatorsForTypeGetter(companies, singleRoutes)
    const landDistanceString = `${landDistance}km`
    const airDistanceString = `${airDistance}km`

    return (
        <>
            <HowToContent
                departure={departure}
                destination={destination}
                singleRoutes={singleRoutes}
                availableVehClasses={availableVehClasses}
                slowestVehClass={slowestInGeneralTransportType}
                fastestVehClass={fastestInGeneralTransportType}
                cheapestVehClass={cheapestInGeneralTransportType}
                priciestVehClass={priciestInGeneralTransportType}
            />
            <HowLongContent
                departure={departure}
                destination={destination}
                singleRoutes={singleRoutes}
                slowestVehClass={slowestInGeneralTransportType}
                fastestVehClass={fastestInGeneralTransportType}
            />
            <HowMuchContent
                departure={departure}
                destination={destination}
                singleRoutes={singleRoutes}
                companies={companies}
                cheapestVehClass={cheapestInGeneralTransportType}
                priciestVehClass={priciestInGeneralTransportType}
            />
            <HowManyTripsContent
                departure={departure}
                destination={destination}
                singleRoutes={singleRoutes}
                cheapestVehClass={cheapestInGeneralTransportType}
                priciestVehClass={priciestInGeneralTransportType}
                totalNumberOfTrips={totalNumberOfTrips}
            />
            <WhatTransportTypeIsTheBestContent
                departure={departure}
                destination={destination}
                distanceLandMiles={landDistanceString}
                singleRoutes={singleRoutes}
                companies={companies}
                slowestVehClass={slowestInGeneralTransportType}
                fastestVehClass={fastestInGeneralTransportType}
                cheapestVehClass={cheapestInGeneralTransportType}
                priciestVehClass={priciestInGeneralTransportType}
            />
            {transportTypes.includes("plane") && (
                <FlightTipsContent
                    departure={departure}
                    destination={destination}
                    routes={singleRoutes.plane}
                    distanceAirMiles={airDistanceString}
                    operators={getAllOperatorsForType("plane")}
                />
            )}
            {transportTypes.includes("bus") && (
                <BusTipsContent
                    departure={departure}
                    destination={destination}
                    priciestVehClass={priciestInGeneralTransportType}
                    distanceLandMiles={landDistanceString}
                    routes={singleRoutes.bus}
                    companies={companies}
                    operators={getAllOperatorsForType("bus")}
                />
            )}
            {transportTypes.includes("ferry") && (
                <FerryTipsContent
                    departure={departure}
                    destination={destination}
                    priciestVehClass={priciestInGeneralTransportType}
                    operators={getAllOperatorsForType("ferry")}
                />
            )}
            {transportTypes.includes("train") && (
                <TrainTipsContent
                    departure={departure}
                    destination={destination}
                    distanceLandMiles={landDistanceString}
                    operators={getAllOperatorsForType("train")}
                />
            )}
            <HowCanIBookContent
                departure={departure}
                destination={destination}
            />
            <WhatIsMostPopularContent
                departure={departure}
                destination={destination}
                singleRoutes={singleRoutes}
                transportTypes={transportTypes}
                ticketsSoldByTransportType={ticketsSoldByTransportType}
            />
        </>
    )
}

export default MultipleTransportTypeContent